import { render, staticRenderFns } from "./jd-button-remote.vue?vue&type=template&id=2df72c74&scoped=true&"
import script from "./jd-button-remote.vue?vue&type=script&lang=js&"
export * from "./jd-button-remote.vue?vue&type=script&lang=js&"
import style0 from "./jd-button-remote.vue?vue&type=style&index=0&id=2df72c74&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df72c74",
  null
  
)

export default component.exports